import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/configuracao`

    return {
        edit() {
            return repository.get(`${baseUrl}/edit`)
        },
        update(params) {
            return repository.put(`${baseUrl}`, params)
        },
    }
}